<div class="business-flow col-12 ml-2">
  <div class="d-flex">
    <h3 class="mt-2 mb-2">JMX Upload</h3>
  </div>
  <form [formGroup]="userForm" (ngSubmit)="submitForm()">
    <div class="singleExcSec d-flex col-12 align-items-center">
      <div class="pb-3 col-3">
        <label>Project</label>
        <ng-select class="required custom-style" required formControlName="project" id="project-name" [items]="userProjects" bindLabel="name" placeholder="Select Project" [searchable]="true" (change)="fetchJMXFiles($event)">
          <ng-option [value]="">Select</ng-option>
        </ng-select>
      </div>
      <div class="pb-3 col-3" ngbTooltip='Select the project first to view or upload the JMX file'>
        <label>JMX File</label>
        <div class="d-flex" [ngClass]="userForm.value.project === null? 'disabled' : ''">
          <ng-select style="width: 90%" [attr.data-items]="files | customList: 'fileName'" [items]="files" id="file-info" name="jmx-file-upload" bindLabel="fileName" [clearable]="false" formControlName="JmxFile" placeholder="Select File">
          </ng-select>
          <div class="ml-auto">
            <input style="display: none" type="file" (change)="onFileChanged($event)" #fileInput>
            <img src="/assets/images/icons/create-plus.svg" (click)="fileInput.click()" class="create-newicon m-2" title="Add new file" placement="center">
          </div>
        </div>
      </div>
      <div class="pb-3 col-3">
        <label>Location</label>
        <ng-select class="required custom-style" required formControlName="location" id="location" [items]="locationList" bindLabel="location" bindValue="location" placeholder="Select Location" [searchable]="true">
          <ng-option [value]="">Select</ng-option>
        </ng-select>
      </div>
    </div>
    <div class="row buttons mt-4 ">
      <div class="col-md-12 text-right">
        <button type="submit" class="btn relay-btn save" >Save</button>
        <button class="btn btn-warning btn-sm" type="button">Cancel</button>
      </div>
    </div>
  </form>
</div>